import styled, { css } from 'styled-components';

import ThemedArrowRightIcon from './ThemedArrowRightIcon';

const defaultSizeInPixels = 48;

export const Circle = styled.div`
    width: ${props => props.size || defaultSizeInPixels}px;
    height: ${props => props.size || defaultSizeInPixels}px;
    grid-area: icon;
    place-self: center left;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    overflow: hidden;
    margin-right: ${props => props.theme.spacers.M};
    > *:nth-child(2) {
        z-index: 1;
    }
`;

export const CircleBackground = styled.div`
    background-color: ${props => props.color};
    position: absolute;
    width: 100%;
    height: 100%;
`;

export const Title = styled.h5`
    ${props => css(props.theme.typography.SuperTinyHeadline)}
    color: ${props => props.theme.colors.Foreground};

    grid-area: title;
    align-self: end;
    max-width: 100%;

    overflow: hidden;
    white-space: nowrap;
    text-align: left;
    text-overflow: ellipsis;
    margin: auto 0;
`;

export const Description = styled.p`
    ${props => css(props.theme.typography.TinyParagraph)}
    color: ${props => props.theme.colors['Level 5']};

    margin: 0;
    grid-area: description;
    align-self: start;
    max-width: 100%;

    overflow: hidden;
    white-space: nowrap;
    text-align: left;
    text-overflow: ellipsis;
`;

export const ArrowRightIcon = styled(ThemedArrowRightIcon)`
    grid-area: arrow-right-icon;
    place-self: center end;

    margin-left: ${props => props.theme.spacers.L};
`;

export const Delimiter = styled.div`
    grid-area: delimiter;
    grid-column: 2 / -1;
    background-color: ${props => props.theme.colors['Level 1']};
`;

export const RippleContainer = styled.div`
    grid-column: 1 / -1;
    grid-row: 1 / -2;
    border-radius: 4px;
`;

export const Content = styled.div`
    position: relative;
    display: grid;
    grid-row-gap: 0;
    grid-template-columns: auto 1fr auto;
    grid-template-rows: 12px auto 5px auto 12px 2px;
    grid-template-areas:
        '. . .'
        'icon title arrow-right-icon'
        'icon . arrow-right-icon'
        'icon description arrow-right-icon'
        '. . .'
        'delimiter delimiter delimiter';

    ${(props) => props.transparent && css`
        ${Circle}, ${Title}, ${Description}, ${ArrowRightIcon} {
            opacity: 0.5;
        }
    `}

    ${(props) => !props.hasDescription && css`
        grid-template-rows: 12px auto 12px 2px;
        grid-template-areas:
            '. . .'
            'icon title arrow-right-icon'
            '. . .'
            'delimiter delimiter delimiter';
    `}
`;
